module.exports = __webpack_public_path__ + "media/images/about-564e07fab3ed93c2ddb8e948d439cf83.jpg";